export enum UnitOfMeasure {
	EACH = 'each',
	BOTTLE = 'bottle',
	BOX = 'box',
	CASE = 'case',
	VIAL = 'vial',
	TUBE = 'tube',
	PACK = 'pack',
	KIT = 'kit',
	JAR = 'jar',
	BAG = 'bag',
	ROLL = 'roll',
	SHEET = 'sheet',
	METER = 'meter',
	LITER = 'liter',
	MILLILITER = 'milliliter',
	GRAM = 'gram',
	KILOGRAM = 'kilogram',
	PALLET = 'pallet',
	OTHER = 'other',
}

/** Display labels for each UnitOfMeasure value */
export const UnitOfMeasureLabels: Record<UnitOfMeasure, string> = {
	[UnitOfMeasure.EACH]: 'Each',
	[UnitOfMeasure.BOTTLE]: 'Bottle',
	[UnitOfMeasure.BOX]: 'Box',
	[UnitOfMeasure.CASE]: 'Case',
	[UnitOfMeasure.VIAL]: 'Vial',
	[UnitOfMeasure.TUBE]: 'Tube',
	[UnitOfMeasure.PACK]: 'Pack',
	[UnitOfMeasure.KIT]: 'Kit',
	[UnitOfMeasure.JAR]: 'Jar',
	[UnitOfMeasure.BAG]: 'Bag',
	[UnitOfMeasure.ROLL]: 'Roll',
	[UnitOfMeasure.SHEET]: 'Sheet',
	[UnitOfMeasure.METER]: 'Meter',
	[UnitOfMeasure.LITER]: 'Liter',
	[UnitOfMeasure.MILLILITER]: 'Milliliter',
	[UnitOfMeasure.GRAM]: 'Gram',
	[UnitOfMeasure.KILOGRAM]: 'Kilogram',
	[UnitOfMeasure.PALLET]: 'Pallet',
	[UnitOfMeasure.OTHER]: 'Other',
};

/** Get the display label for a UOM value, falling back to the raw value or empty string */
export function getUnitOfMeasureLabel(uom: string | null | undefined): string {
	if (uom == null) return '';
	return UnitOfMeasureLabels[uom as UnitOfMeasure] ?? uom;
}

/** Pre-built options array for Select dropdowns */
export const UOM_OPTIONS: Array<{
	value: UnitOfMeasure;
	label: string;
}> = Object.values(UnitOfMeasure).map((value) => ({
	value,
	label: UnitOfMeasureLabels[value],
}));
